import { memo } from 'react'

import { TextProps } from '@chakra-ui/react'

import { ClickableLocation } from '@wwt/widgets/map/ui/ClickableLocation.tsx'

import { cn } from '@/shared/lib/cn'

import { useOfferCardLocation } from '../../model/useOfferCardLocation.ts'
import { OfferCardInnerProps } from '../../types/OfferCardInnerProps.ts'

interface OfferCardLocationProps extends OfferCardInnerProps {
	onClick: () => void
	isDisabled?: boolean
	hasClickableLocation?: boolean
	clickableLocationProps?: TextProps & { isTrimmed?: boolean }
}

/**
 *
 *
 * @author Ivan Shchedrovskyi
 */
export const OfferCardLocation = memo(
	({
		offer,
		onClick,
		isDisabled = false,
		hasClickableLocation,
		className,
		clickableLocationProps
	}: OfferCardLocationProps) => {
		const { coordinates, location, nonPersistingOfferId } =
			useOfferCardLocation(offer, hasClickableLocation)

		if (coordinates)
			// TODO: Refactor after rewrite ClickableLocation to tailwind
			return (
				<ClickableLocation
					data-wwt-id="offer-card__location-button--unique"
					id={nonPersistingOfferId}
					location={location}
					coordinates={coordinates}
					onClick={onClick}
					color="gray.300"
					transition="100ms"
					textStyle="body-text-7"
					_hover={
						isDisabled
							? {}
							: {
									color: 'brand.200'
								}
					}
					textAlign="left"
					lineHeight="base"
					zIndex={0}
					{...clickableLocationProps}
				/>
			)

		return (
			<div
				className={cn('mt-2 text-left text-gray-300', className)}
				title={location}
			>
				{location}
			</div>
		)
	}
)

OfferCardLocation.displayName = 'OfferCardLocation'
